import * as React from "react";
import { Divider, Typography, Icon } from "antd";
import PDFExportLink from "../../components/app/PDFExportLink";
import ReportPreview from "../../components/app/ReportPreview";
import { IReport5Presenter } from "../../../presenter/report/Report5Presenter";
import Report5ParamBox from "../../components/report/Report5ParamBox";

export interface Props {}

export interface State extends IReport5Presenter {}

export default class Report5Page extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      report5ReportingPeriodList,
      onChangeReportingPeriod,
      report5CurrentReportingPeriod,
      translate,
      getPDFReport5,
      report5
    } = this.state;

    return (
      <div className={"report-container"}>
        <Report5ParamBox
          currentReportingPeriod={report5CurrentReportingPeriod}
          reportingPeriodList={report5ReportingPeriodList}
          onChangeReportingPeriod={onChangeReportingPeriod}
          getPDFReport={getPDFReport5}
          translate={translate}
          loading={this.state.loaders.report5Loader}
          title={translate("reports.params.reporting_period")}
        />
        <Divider type={"vertical"} style={{ height: "100%" }} />
        {report5 && (
          <div style={{ width: "75%", paddingLeft: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <Typography.Title style={{ fontSize: 14 }}>
                {translate("reports.review_report")}
              </Typography.Title>
              <div>
                {!this.state.loaders.report5Loader && (
                  <PDFExportLink
                    translate={translate}
                    data={report5}
                    title={report5CurrentReportingPeriod?.name}
                    subtitle={translate("reports.report_5")}
                    fileName={`${translate("reports.report_5")}.pdf`}
                  />
                )}
                <Divider
                  type={"vertical"}
                  style={{ fontSize: 10, height: "100%" }}
                />
                <a
                  key="file-excel"
                  href={`/api/reports/report5/reporting-periods/${report5CurrentReportingPeriod?.id}/xlsx`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon
                    type="file-excel"
                    theme={"outlined"}
                    style={{ fontSize: 20, color: "#20744B" }}
                  />
                </a>
              </div>
            </div>
            <Divider type={"horizontal"} />
            <ReportPreview
              translate={translate}
              data={report5}
              title={report5CurrentReportingPeriod?.name}
              subtitle={translate("reports.report_5")}
            />
          </div>
        )}
      </div>
    );
  }
}
